<template>
    <button class="bg-primary transform hover:scale-110 text-white font-bold py-2 px-4 rounded">
        <slot></slot>
    </button>
</template>
<script>

</script>